import Dialog from './ui/Dialog';
export { DialogTitle } from './ui/DialogTitle/DialogTitle';
export { Dialog as DialogContainer, DialogActions } from '@mui/material';
export { DialogCloseButton } from './ui/DialogCloseButton/DialogCloseButton';
export { DialogContent } from './ui/DialogContent/DialogContent';
export default Dialog;
